import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Promo')

const getDefaultState = () => ({
  activePromos: {},
  promos: {},
  promoActive: false,
  promoMode: null,
  promoText: null,
  promoDismissed: null
})

export const state = getDefaultState

export const mutations = {
  ADD_ACTIVE_PROMO (state, { id, code }) {
    if (!(id in state.promos)) return
    // Only allow one active promo at a time
    state.activePromos = {
      [id]: { id, code, ...state.promos[id] }
    }
    state.promoDismissed = null
  },
  SET_PROMOS (state, response) {
    state.promoActive = response.promo_active
    state.promoMode = response.mode || state.promoMode
    state.promoText = response.banner_text || state.promoText
    state.promos = response.enhanced_promos || {}
  },
  SET_ENHANCED_PROMOS (state, enhancedPromos) {
    state.promos = enhancedPromos || {}
  },
  DISMISS_PROMO (state, isDismissed = true) {
    state.promoDismissed = isDismissed ? (new Date()).valueOf() : null
  }
}

const testPromoIsValid = (promo) => {
  if (promo.promoStart && promo.promoStart > new Date().valueOf()) return false
  if (promo.promoEnd && promo.promoEnd < new Date().valueOf()) return false
  if (promo.pattern && typeof promo.pattern !== 'string') return false
  return true
}

export const getters = {
  activePromos: state => Object.values(state.activePromos).filter(testPromoIsValid),
  activePromoWithBanner: (state, getters) => getters.activePromos.find(promo => promo.banner) || {},
  activePromoForProduct: (state, getters) => sku => getters.activePromos.find(promo => (sku || '').match(new RegExp(promo.pattern))),
  casePromoActive: (state, getters) => getters.promoActive && ['FREE_CAPSULE', 'FREE_SHIPPING_AND_CAPSULE'].includes(getters.promoMode),
  shippingPromoActive: (state, getters) => getters.promoActive && ['FREE_SHIPPING', 'FREE_SHIPPING_AND_CAPSULE'].includes(getters.promoMode),
  promoActive: (state, getters) => state.promoActive || getters.activePromos.filter(promo => promo.banner).length,
  promoMode: (state, getters) => getters.activePromoWithBanner.mode || state.promoMode,
  promoText: (state, getters) => getters.activePromoWithBanner.banner || state.promoText,
  promoDismissed: state => state.promoDismissed !== null && state.promoDismissed > (new Date()).valueOf() - 86400 * 1000
}

export const actions = {
  async GET_PROMOS ({ state, commit }, enhancedOnly = false) {
    logger.debug('GET_PROMOS')
    const { data } = await this.$publicAPI.quietGet('config/promo/', { useCache: true })
    
    if (enhancedOnly) commit('SET_ENHANCED_PROMOS', data.enhanced_promos)
    else commit('SET_PROMOS', data)
    
    logger.debug('GET_PROMOS - done')
  }
}
